import { RouteRecordRaw } from 'vue-router'

const signupRoutes: RouteRecordRaw = {
  path: '/signup',
  name: 'Signup',
  component: () => import('@/layouts/Authentication.vue'), // Set Authentication.vue as the layout
  meta: {
    title: 'Signup'
  },
  children: [
    {
      path: '', // Default child route
      name: 'SignupForm',
      component: () => import('@/views/Signup/Signup.vue'), // Specific signup view
      meta: {
        title: 'Signup Form'
      }
    }
  ]
}

export default signupRoutes
